export default {
    LOAD_USER(state, user) {
        state.items = user
    }
}